import getEnv from '../../get-env'
import match from 'js-pattern-matching'
import { checkPhoneStatus, getTempRedirectTokenAPI, signout, userInfo } from '@/services/module/user'
import store from '../store'
import { getBrowserEnv, isMobile, urlDelParams } from '@/utils/tools'
import { gc, gls, rls, sls } from '@/utils/storage'
import router from '@/router/index'
import Vue from 'vue'
import { getJxfHomeHref } from 'cmm-common-lib/utils/getHomeHref'
import wx from 'weixin-js-sdk'
import { INSIDE_APPID } from '@/utils/storage-const'
import { userLogin } from '@/utils/app/js-bridge'
import { isInApp } from '@/utils/app-communication'

function getLoginPageUrl(callBackUrl) {
  if (isMobile()) {
    return getCMMWapAddress() + `/prelogin?callback_url=${callBackUrl}`
  }
  return getCMMAddress() + `/entry/login?from=${callBackUrl}&source=10009`
}

// export function gotoLogin ({ callBackUrl = null } = {}) {
//   LoginDialog.open()
//   return
//   let href = location.href
//   if (callBackUrl) {
//     href = callBackUrl
//   }
//   window.location.href = getLoginPageUrl(encodeURIComponent(href))
// }
export const keyName = 'login-callback-url'

// 2025-4 切片域名重定向到蝉剪
export async function gotoCxLogin({ callBackUrl = null, insideAppId = null } = {}) {
  let href = callBackUrl ?? location.href
  href = urlDelParams(href, 'cx-token')
  console.log('href', href)
  const currentInsideAppId = insideAppId ?? router.currentRoute?.query?.insideAppId
  if (currentInsideAppId == '1' || currentInsideAppId == '2') {
    const browserEnv = await getBrowserEnv()
    if (browserEnv === 'miniProgram') {
      sls('miniProgramRedirection', href)
      const url =
        insideAppId == '1'
          ? `/pages/login/index?fromWebSrc=${encodeURIComponent(href)}`
          : `/pagesA/common/login/index?fromWebSrc=${encodeURIComponent(href)}`
      wx.miniProgram.navigateTo({ url })
      return false
    }
  }
  if (isInApp()) {
    console.log('跳转去app登录')
    userLogin()
    return false
  }
  if (isMobile()) {
    window.location.href = `${getJXAddress()}/login/transit?from=${encodeURIComponent(href)}&req-temp-token=1`
  } else {
    window.location.href = `${getChanjianHomeHref()}/login/transit?from=${encodeURIComponent(
      href
    )}&req-temp-token=1`
  }
}

// redirect 是否重定向回首页 默认返回；closeWebview 用于退出后关闭小程序 web-view
export async function exitCxLogin({ redirect = true, closeWebview = false } = {}) {
  const browserEnv = await getBrowserEnv()
  if (browserEnv === 'miniProgram') {
    const insideAppId = gc(INSIDE_APPID)

    if (closeWebview) {
      wx.miniProgram.postMessage({ data: { cmd: 'logout', logout: true } })
      wx.miniProgram.navigateBack({ delta: 1 })
      return true
    }
    if (insideAppId) {
      wx.miniProgram.postMessage({ data: { cmd: 'logout', logout: true } })
      const url = insideAppId == '1' ? `/pages/index/index` : `/pagesA/qiepian/index`
      redirect && wx.miniProgram.redirectTo({ url })
    }
    return true
  }
  return false
}

/**
 * @deprecated 不建议用这个方法 用 gotoCxLogin替代
 */
export function gotoLogin({
  isCallBack = true,
  callBackUrl = null,
  isReplace = false,
  source = null,
  reqToken = false
} = {}) {
  const isLoginPage = store.state.route.currentPage?.meta?.isLoginPage
  if (isLoginPage) {
    return
  }
  let href = location.href
  if (callBackUrl) {
    href = callBackUrl
  }
  if (isCallBack) {
    sls(keyName, href)
  } else {
    rls(keyName)
  }

  const goto = (obj) => {
    if (isReplace) {
      return router.replace(obj)
    } else {
      return router.push(obj)
    }
  }
  const name = do {
    if (location.href.includes('h5/video-clip') && isMobile()) {
      ;('h5-sms-login')
    } else {
      ;('login')
    }
  }
  goto({ name }).catch(console.log)
}

export function loginAfter() {
  const callbackUrl = gls(keyName)
  if (callbackUrl) {
    if (callbackUrl.indexOf('/login') != -1) {
      goDefaultHome()
    } else {
      // /*回跳的时候拼接token*/
      // if (reqToken) {
      //   const c = callbackUrl.indexOf('?') == -1 ? '?' : '&'
      //   callbackUrl = `${callbackUrl}${c}cmm-token=${store.state.user.token}`
      // }
      location.href = callbackUrl
    }
  } else {
    goDefaultHome()
  }
}

function goDefaultHome() {
  router.push({ name: 'Home' }).catch(console.log)
}

export async function exitLogin() {
  await signout({}, { commonCheck: false })
  store.dispatch('user/clearToken', false)
  store.dispatch('user/clearUserInfo', false)
}

// 根据手机获取账号注册和微信绑定状态
export async function isWechatBindPhoneOk(phone, isBindNew = true) {
  try {
    const {
      data: { data, errCode, errMsg }
    } = await checkPhoneStatus({ phone })
    if (errCode != 0) {
      Vue.prototype.$message.error(errMsg)
      return false
    } else {
      const { registration, bind_wechat } = data
      // 绑定已有账号
      if (!isBindNew) {
        if (!registration) {
          Vue.prototype.$message.error('该手机号未注册')
          return false
        }
        if (bind_wechat) {
          Vue.prototype.$message.error('该手机号已经绑定了微信')
          return false
        }
      } else {
        // 绑定新账号
        if (registration) {
          Vue.prototype.$message.error('该手机号已经注册')
          return false
        }

        if (bind_wechat) {
          Vue.prototype.$message.error('该微信已绑定')
          return false
        }
      }

      return true
    }
  } catch (e) {
    console.log(e)
    return false
  }
}

export async function onLoginSuccess() {
  try {
    const {
      data: { data, errCode }
    } = await userInfo()
    if (errCode != 0) {
      return
    }
    await store.dispatch('user/updateUserInfo', data)
    loginAfter()
  } catch (e) {
    console.log(e)
  }
}

/*获取蝉妈妈地址*/
export function getCMMAddress() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://sv-test.cds8.cn',
    (v = 'test') => 'https://sv-test.cds8.cn',
    (v = 'stage') => 'https://sv-stage.cds8.cn',
    (v = 'prod') => 'https://www.chanmama.com',
    (_) => ''
  )
}

/*获取蝉妈妈m站地址*/
export function getCMMWapAddress() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://sv-test-m.cds8.cn/#/h5',
    (v = 'test') => 'https://sv-test-m.cds8.cn/#/h5',
    (v = 'stage') => 'https://sv-stage-m.cds8.cn/h5',
    (v = 'prod') => 'https://m.chanmama.com/h5',
    (_) => ''
  )
}

/*获取抖客地址*/
export function getDKAddress() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://cmm-dk-test.cds8.cn',
    (v = 'test') => 'https://cmm-dk-test.cds8.cn',
    (v = 'stage') => 'https://cmm-dk-stage.cds8.cn',
    (v = 'prod') => 'https://douke.chanmama.com',
    (_) => ''
  )
}

/*获取蝉选切片地址*/
export function getCXQiepianAddress() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://cx-qiepian-test.cds8.cn',
    (v = 'test') => 'https://cx-qiepian-test.cds8.cn',
    (v = 'stage') => 'https://cx-qiepian-stage.cds8.cn',
    (v = 'prod') => 'https://qiepian.chanxuan.com',
    (_) => ''
  )
}
/*获取独立工具地址*/
export function getChanjianRecordToolHomeHref() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://cx-clip-tool-dev.cds8.cn',
    (v = 'test') => 'https://cx-clip-tool-dev.cds8.cn',
    (v = 'stage') => 'https://cx-clip-tool-stage.cds8.cn',
    (v = 'prod') => 'https://tool.chanjian.cc',
    (_) => ''
  )
}
export function getAppInlineH5Url() {
  switch (getEnv()) {
    case 'dev':
      return 'https://cx-h5app-test.cds8.cn'
    case 'test':
      return 'https://cx-h5app-test.cds8.cn'
    case 'stage':
      return 'https://cx-h5app-stage.cds8.cn'
    case 'prod':
      return 'https://h5app.chanxuan.com'
    default:
      return 'https://h5app.chanxuan.com'
  }
}
/*获取蝉选地址*/
export function getJXAddress() {
  const ENV = getEnv()
  return match(ENV)(
    (v = 'dev') => 'https://cmm-jingxuan-test.cds8.cn',
    (v = 'test') => 'https://cmm-jingxuan-test.cds8.cn',
    (v = 'stage') => 'https://cmm-jingxuan-stage.cds8.cn',
    (v = 'prod') => 'https://www.chanxuan.com',
    (_) => ''
  )
}
export function getChanjianHomeHref() {
  let host = ''
  switch (getEnv()) {
    case 'dev':
      host = 'https://ck-clip-test.cds8.cn'
      break

    case 'test':
      host = 'https://ck-clip-test.cds8.cn'
      break

    case 'stage':
      host = 'https://ck-clip-stage.cds8.cn'

      break

    case 'prod':
      host = 'https://www.chanjian.cc'
      break
  }
  return host
}

export async function goWithTempToken(url) {
  const temp = await getTempRedirectToken()
  if (temp) {
    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}cx-temp-token=${temp}`
  } else {
    return url
  }
}

/**
 * 获取临时跳转凭证
 *
 * @function getTempRedirectToken
 * @returns {Promise<string>} 返回一个Promise，解析后的值是临时跳转凭证
 */
export async function getTempRedirectToken() {
  const token = store?.state?.user?.token
  if (!token) {
    return ''
  } else {
    try {
      const {
        data: { data, errCode, errMsg }
      } = await getTempRedirectTokenAPI()
      if (errCode !== 0) {
        Vue.prototype.$message.error(errMsg)
        return ''
      } else {
        return data
      }
    } catch (e) {
      console.log(e)
      return ''
    }
  }
}
